
import { Component, Vue, Prop, Watch} from 'vue-property-decorator';

import CashAssetsFsSurvey from "./CashAssetsFSSurvey.vue";
import { stepInfoType, stepResultInfoType } from "@/types/Application";

import PageBase from "../../PageBase.vue";


import { namespace } from "vuex-class";   
import "@/store/modules/application";
const applicationState = namespace("Application");

@Component({
    components:{
      CashAssetsFsSurvey,
      PageBase
    }
})
export default class CashAssetsFS extends Vue {
  
    @Prop({required: true})
    step!: stepInfoType

    @applicationState.Action
    public UpdateStepResultData!: (newStepResultData: stepResultInfoType) => void
    

    @Watch('cashAssetsData')
    cashAssetsDataChange(newVal) 
    {
        this.UpdateStepResultData({step:this.step, data: {cashAssetsFSSurvey: this.getCashAssetsResults()}})  
    }

    currentStep =0;
    currentPage =0;
    showTable = true;
    cashAssetsData = [];
    anyRowToBeEdited = null;
    editId = null;
 
    created() {
        if (this.step.result?.cashAssetsFSSurvey?.data) {
            this.cashAssetsData = this.step.result.cashAssetsFSSurvey.data;
        }
    }

    mounted(){        
        const progress = this.cashAssetsData?.length>0? 100 : 50;            
        this.currentStep = this.$store.state.Application.currentStep;
        this.currentPage = this.$store.state.Application.steps[this.currentStep].currentPage;
        Vue.filter('setSurveyProgress')(null, this.currentStep, this.currentPage, progress, false);
    }
    
    public openForm(anyRowToBeEdited?) {
        this.showTable = false;
        Vue.nextTick(()=>{
            const el = document.getElementById('cash-assets-fs-survey')
            if(el) el.scrollIntoView();
        })
        if(anyRowToBeEdited) {
            this.editId = anyRowToBeEdited.id;
            this.anyRowToBeEdited = anyRowToBeEdited;
        } else {
            this.anyRowToBeEdited = null;
        }
    }

    public childComponentData(value) {
        this.showTable = value;
    }

    public populateSurveyData(cashAssetsValue) {
        const currentIndexValue = this.cashAssetsData?.length > 0 ? this.cashAssetsData[this.cashAssetsData.length - 1].id : 0;
        const id = currentIndexValue + 1;
        const newCashAssets = { ...cashAssetsValue, id };

        this.cashAssetsData = this.cashAssetsData? [...this.cashAssetsData, newCashAssets]:[newCashAssets];

        this.showTable = true; 
    }

    public deleteRow(rowToBeDeleted) {
        this.cashAssetsData = this.cashAssetsData.filter(data => {
            return data.id !== rowToBeDeleted;
        });
    }

    public editRow(editedRow) {
        this.cashAssetsData = this.cashAssetsData.map(data => {
            return data.id == this.editId ? editedRow : data;
        });
        this.showTable = true;
    }

    public onPrev() {
        Vue.prototype.$UpdateGotoPrevStepPage()
    }

    public onNext() {
        Vue.prototype.$UpdateGotoNextStepPage();
    }

    public isDisableNext() {    
        if(this.cashAssetsData?.length > 0) return false;
        else return true;
    }    

    beforeDestroy() {
        const progress = this.cashAssetsData?.length>0? 100 : 50;
        Vue.filter('setSurveyProgress')(null, this.currentStep, this.currentPage, progress, true);
        this.UpdateStepResultData({step:this.step, data:{cashAssetsFSSurvey: this.getCashAssetsResults()}})       
    }
   
    public getCashAssetsResults(){
        const questionResults: {name:string; value: string[]; title:string; inputType:string}[] =[];
        if(this.cashAssetsData)
            for(const cashAssets of this.cashAssetsData)
            {
                questionResults.push({name:'cashAssetsFSSurvey', value: this.getCashAssetsInfo(cashAssets), title:'Cash assets '+cashAssets.id +' Information', inputType:''})
            }

        return {data: this.cashAssetsData, questions:questionResults, pageName:'Cash assets', currentStep: this.currentStep, currentPage:this.currentPage}
    }

    public getCashAssetsInfo(cashAssets){        
        const resultString: string[] = [];
        resultString.push(Vue.filter('styleTitle')("Description: ")+cashAssets.cashAssetsDescription);
        resultString.push(Vue.filter('styleTitle')("Value: ")+cashAssets.cashAssetsValue);
        return resultString
    }

}
